import {Alert} from "../../shared/Alert/Alert";
import {Trans} from "react-i18next";
import {Link} from "react-router-dom";
import React from "react";
import {useOidcClientContext} from "../../context/OidcClientContext";
import useCustomerContext from "../../../customers/hooks/useCustomerContext";

const LoginOrRegisterMsg = () => {
    const {authenticated, client} = useOidcClientContext();
    const {languageCode} = useCustomerContext();

    const handleLogin = () => client.login({
        locale: languageCode,
    });
    const handleRegister = () => client.register({
        locale: languageCode,
    });

    if (authenticated) {
        return null;
    }

    return (
        <Alert type="success" closable={false} containerClassName="mb-5">
            <p className="mb-1">
            <Trans
                i18nKey="common.actions.loginOrRegisterMsg"
                components={{
                    LoginLink: <Link
                        to="#login"
                        onClick={handleLogin}
                        className={"underline font-medium hover:no-underline"}
                    />,
                    RegisterLink: <Link
                        to="#register"
                        onClick={handleRegister}
                        className={"underline font-medium hover:no-underline"}
                    />,
                }}
            />
            </p>
        </Alert>
    );
};

export default LoginOrRegisterMsg;
